import { Box, Card, CardContent, Typography } from '@mui/material'
import { ReactNode } from 'react'

export const BranchBadge = ({
	background,
	children,
	color,
}: {
	background: string
	children: ReactNode
	color: string
}) => (
	<Box
		component="span"
		sx={{
			display: 'inline-flex',
			alignItems: 'center',
			gap: 0.5,
			borderRadius: '4px',
			px: 0.75,
			py: 0.25,
			fontSize: 8.5,
			fontWeight: 700,
			letterSpacing: '0.03em',
			textTransform: 'uppercase',
			color,
			bgcolor: background,
		}}
	>
		{children}
	</Box>
)

export const BranchStatCard = ({
	flex = '1 1 140px',
	label,
	value,
}: {
	flex?: string
	label: string
	value: string
}) => (
	<Card
		variant="outlined"
		sx={{
			flex,
			minWidth: 130,
			borderColor: '#ECECEC',
			borderRadius: '10px',
			boxShadow: 'none',
		}}
	>
		<CardContent sx={{ p: '12px 14px !important' }}>
			<Typography sx={{ fontSize: 22, fontWeight: 800, color: '#1F4954', lineHeight: 1.1 }}>
				{value}
			</Typography>
			<Typography sx={{ fontSize: 11, color: '#9A9A9A', fontWeight: 600, mt: 0.5 }}>
				{label}
			</Typography>
		</CardContent>
	</Card>
)

export const BranchSection = ({
	children,
	title,
}: {
	children: ReactNode
	title: string
}) => (
	<Box
		sx={{
			border: '1px solid #E8E8E8',
			borderRadius: '10px',
			p: '16px 18px',
			mt: 2,
			bgcolor: '#fff',
		}}
	>
		<Typography
			sx={{
				mb: 1.5,
				fontSize: 10.5,
				fontWeight: 700,
				letterSpacing: '0.08em',
				textTransform: 'uppercase',
				color: '#9A9A9A',
			}}
		>
			{title}
		</Typography>
		{children}
	</Box>
)

export const BranchMetaRow = ({ label, value }: { label: string; value: string }) => (
	<Box
		sx={{
			display: 'flex',
			gap: 1.25,
			py: 0.75,
			borderTop: '1px solid #EFEFEF',
			'&:first-of-type': { borderTop: 0, pt: 0 },
		}}
	>
		<Typography sx={{ flex: '0 0 130px', fontSize: 12.5, fontWeight: 600, color: '#9A9A9A' }}>
			{label}
		</Typography>
		<Typography sx={{ fontSize: 12.5, color: '#3D3D3D' }}>{value}</Typography>
	</Box>
)
